import React from 'react';

import { type InputNumberProps } from './types';
import { maxWithinBounds, MIN_STEP } from './utilities';

import { Input } from './styles';

export function InputNumber({
    value,
    id,
    name,
    placeholder,
    min,
    max,
    step = MIN_STEP,
    disabled = false,
    onFocus,
    onBlur,
    onChange,
    onKeyDown,
}: InputNumberProps) {
    const safeMax = maxWithinBounds({ min, max });
    const safeStep = Math.max(MIN_STEP, step);

    return (
        <Input
            value={value}
            id={id}
            name={name}
            placeholder={placeholder}
            min={min}
            max={safeMax}
            step={safeStep}
            disabled={disabled}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={onChange}
            onKeyDown={onKeyDown}
        />
    );
}
